import { FilterFloat } from './FilterFloat';
import { FilterInteger } from './FilterInteger';

export default {
  Float: FilterFloat,
  Integer: FilterInteger,
};
